const ro = {
  meta: {
    home: { title: "Centauros — Încasează fără să alergi după clienți", description: "Definește politici de încasare, automatizează mementourile, generează facturi și încasează fără să alergi după nimeni. Totul de pe telefon." },
    privacy: { title: "Politica de confidențialitate — Centauros", description: "Cum protejează și prelucrează Centauros datele tale." },
    terms: { title: "Termeni și condiții — Centauros", description: "Condiții de utilizare a Centauros." },
    support: { title: "Suport — Centauros", description: "Ajutor și răspunsuri despre Centauros." },
    contact: { title: "Contact — Centauros", description: "Contactează echipa Centauros." },
  },
  nav: { features: "Funcții", how: "Cum funcționează", faq: "Întrebări", contact: "Contact", download: "Descarcă", dashboard: "Panou" },
  hero: {"line1": "Să încasezi nu ar trebui", "line2": "să fie încă o slujbă.", "subtitle": "Stabilește regulile de la început, automatizează urmărirea și nu mai alerga după clienți ca să încasezi.", "functional": "Centauros îți permite să definești politici de încasare, să automatizezi mementouri, să generezi facturi și să ții fiecare plată sub control.", "ctaPrimary": "Descarcă Centauros", "ctaSecondary": "Vezi cum funcționează", "note": "Fără taxe ascunse · Plăți sigure cu Stripe", "availability": "Disponibil pentru iPhone și Android"},
  marquee: ["Creat pentru profesioniștii ecvestri", "Sigur", "Rapid", "De încredere", "Încasează fără să alergi"],
  problem: {"label": "Problema", "title": "Să încasezi este problema. Munca bună nu ajunge dacă încasarea devine încă o slujbă.", "intro": "Ești plătit târziu, alergi după clienți și avansezi timp, materiale și bani. Acestea sunt costurile reale.", "chapters": [{"n": "01", "title": "Plăți care vin târziu", "text": "Ajungi să finanțezi clientul cu timpul și banii tăi."}, {"n": "02", "title": "Alergi după clienți", "text": "Mesaje, apeluri și e-mailuri incomode care ar trebui să poată fi evitate."}, {"n": "03", "title": "Reguli neclare", "text": "Când condițiile nu se fixează la început, a cere mai târziu creează conflict."}, {"n": "04", "title": "Neîncasări fără previziune", "text": "Să nu știi ce vei încasa, când, și ce este scadent."}, {"n": "05", "title": "Cost de oportunitate", "text": "Fiecare oră de reclamat este o oră în minus de lucru sau de atras clienți."}]},
  solution: {
    label: "Soluția",
    title: "Centauros automatizează încasarea, de la cap la coadă.",
    subtitle: "Configurează o dată. Lasă-l să lucreze pentru tine.",
    items: ["Politici de încasare", "Mementouri", "Facturi", "Plăți", "Urmărire", "Reconciliere"],
    footer: "Totul de pe telefon.",
  },
  how: {
    label: "Cum funcționează",
    title: "Patru pași. Zero fricțiune.",
    steps: [
      { title: "Creează client", text: "Adaugă clientul în câteva secunde." },
      { title: "Alege politica", text: "Definește când și cum se încasează automat." },
      { title: "Trimite", text: "Centauros emite și trimite factura pentru tine." },
      { title: "Încasează", text: "Plata vine singură. Fără mementouri manuale." },
    ],
  },
  screens: {
    label: "Ecrane",
    title: "Proiectat cu atenție obsesivă la detalii.",
    subtitle: "Fiecare ecran gândit ca să facă încasarea invizibilă.",
    items: [
      { title: "Încasări", text: "Tot ce ți se cuvine, dintr-o privire." },
      { title: "Politici", text: "Reguli de încasare clare și reutilizabile." },
      { title: "Facturi", text: "Generează și trimite cu o atingere." },
      { title: "Plăți", text: "Sigure, cu Stripe, în timp real." },
    ],
  },
  features: {
    label: "Funcții",
    title: "Tot ce ai nevoie ca să încasezi mai bine.",
    cards: [
      { title: "Control total", text: "O imagine clară a fiecărei plăți și a fiecărui client." },
      { title: "Automatizare", text: "Sarcinile repetitive se execută singure." },
      { title: "Facturare", text: "Facturi profesionale generate instant." },
      { title: "Încasări", text: "Plăți automate conform politicilor tale." },
      { title: "Echipă", text: "Invită-ți echipa și lucrați împreună." },
      { title: "Securitate", text: "Infrastructură sigură și date protejate." },
      { title: "Plăți", text: "Încasează cu cardul în siguranță prin Stripe." },
      { title: "Istoric", text: "Fiecare mișcare înregistrată și reconciliată." },
    ],
  },
  audience: {
    label: "Pentru cine este",
    title: "Făcut pentru cei care trăiesc din munca lor.",
    subtitle: "Dacă timpul tău contează, Centauros e pentru tine.",
    roles: ["Medici veterinari", "Potcovari", "Antrenori", "Transportatori", "Profesioniști ecvestri"],
    note: "Și orice profesionist care vrea să încaseze mai bine.",
  },
  security: {
    label: "Securitate",
    title: "Banii și datele tale, protejate.",
    subtitle: "Construit pe infrastructură de încredere.",
    points: [
      { title: "Plăți cu Stripe", text: "Procesăm plățile cu standardul de top din industrie." },
      { title: "Infrastructură sigură", text: "Criptare în tranzit și în repaus." },
      { title: "Confidențialitate", text: "Datele tale sunt ale tale. Nu le vindem niciodată." },
      { title: "Protecția datelor", text: "Conformitate și bune practici prin design." },
      { title: "Fără carduri stocate", text: "Nu stocăm niciodată datele cardurilor." },
    ],
  },
  faq: {
    label: "Întrebări frecvente",
    title: "Tot ce vrei să știi.",
    items: [
      { q: "Ce este Centauros?", a: "O aplicație pentru a defini politici de încasare, a automatiza mementouri, a genera facturi și a încasa fără să alergi după nimeni." },
      { q: "Am nevoie de cunoștințe tehnice?", a: "Nu. Se configurează în câteva minute și funcționează de pe telefon." },
      { q: "Cum sunt procesate plățile?", a: "Plățile sunt procesate în siguranță prin Stripe." },
      { q: "Stocați datele cardului meu?", a: "Niciodată. Nu stocăm date de card în niciun moment." },
      { q: "Pot automatiza mementourile?", a: "Da. Definește politica o dată, iar Centauros se ocupă de rest." },
      { q: "Pot genera facturi?", a: "Da, facturi profesionale instant, gata de trimis." },
      { q: "Funcționează pentru profesia mea?", a: "Este creat pentru profesioniștii ecvestri și pentru oricine vrea să încaseze mai bine." },
      { q: "Pot lucra cu echipa mea?", a: "Da, poți invita echipa și colabora." },
      { q: "Este disponibil în mai multe limbi?", a: "Da, Centauros este disponibil în 12 limbi." },
      { q: "De unde îl pot descărca?", a: "În curând în App Store pentru iPhone." },
    ],
  },
  finalCta: { title: "Începe astăzi.", subtitle: "Descarcă Centauros și nu mai alerga după clienți.", badge: "Descarcă din App Store" },
  footer: {
    statement1: "Să încasezi nu mai este",
    statement2: "încă o slujbă.",
    download: "Descarcă Centauros",
    secure: "Plăți sigure",
    tagline: "Încasează fără să alergi după clienți.",
    colProduct: "Produs", colCompany: "Companie", colLegal: "Legal",
    links: { home: "Acasă", features: "Funcții", faq: "Întrebări", contact: "Contact", privacy: "Confidențialitate", terms: "Termeni", support: "Suport", download: "Descarcă" },
    contactLabel: "Contact",
    rights: "© Centauros. Toate drepturile rezervate.",
  },
  contact: {
    title: "Hai să vorbim.",
    subtitle: "Ai o întrebare sau vrei să afli mai multe? Scrie-ne.",
    fields: { name: "Nume", email: "Email", subject: "Subiect", message: "Mesaj" },
    placeholders: { name: "Numele tău", email: "tu@email.com", subject: "Cum te putem ajuta?", message: "Spune-ne..." },
    submit: "Trimite mesajul", sending: "Se trimite...", success: "Mesaj trimis. Îți răspundem în curând.", error: "Nu s-a putut trimite. Încearcă din nou.", directLabel: "Sau scrie-ne direct la",
  },
  legal: {
    privacy: {
      title: "Politica de confidențialitate", updated: "Ultima actualizare: iunie 2026",
      body: [
        { h: "Introducere", p: "La Centauros luăm confidențialitatea în serios. Această politică explică ce date prelucrăm și de ce." },
        { h: "Date prelucrate", p: "Prelucrăm datele necesare serviciului: contul tău, clienții pe care îi gestionezi și plățile efectuate." },
        { h: "Plăți", p: "Plățile trec prin Stripe. Nu stocăm niciodată datele cardului tău sau ale clienților tăi." },
        { h: "Utilizarea datelor", p: "Folosim datele doar pentru a furniza și îmbunătăți serviciul. Nu vindem niciodată informațiile tale." },
        { h: "Drepturile tale", p: "Poți accesa, rectifica sau șterge datele oricând, scriind la support@centauros.app." },
      ],
    },
    terms: {
      title: "Termeni și condiții", updated: "Ultima actualizare: iunie 2026",
      body: [
        { h: "Acceptare", p: "Folosind Centauros accepți acești termeni. Dacă nu ești de acord, nu utiliza serviciul." },
        { h: "Utilizarea serviciului", p: "Te angajezi să folosești Centauros legal și să-ți păstrezi contul în siguranță." },
        { h: "Plăți", p: "Plățile sunt procesate prin Stripe conform condițiilor sale. Ești responsabil de relația cu clienții." },
        { h: "Răspundere", p: "Centauros este oferit „ca atare”. Lucrăm pentru disponibilitate și securitate continue." },
        { h: "Modificări", p: "Putem actualiza acești termeni. Vom notifica modificările relevante prin aplicație." },
      ],
    },
    support: {
      title: "Suport", updated: "Suntem aici să te ajutăm.",
      intro: "Găsește răspunsuri rapide sau contactează-ne direct. Răspundem cât mai repede posibil.",
      faqs: [
        { q: "Cum încep?", a: "Descarcă aplicația, creează-ți contul și adaugă primul client în câteva minute." },
        { q: "Cum automatizez încasările?", a: "Creează o politică de încasare și atribuie-o clienților. Restul e automat." },
        { q: "Am o problemă cu o plată?", a: "Scrie la support@centauros.app și verificăm împreună." },
        { q: "Pot exporta datele mele?", a: "Da, poți solicita un export oricând." },
      ],
      contactLine: "Ai nevoie de mai mult ajutor? Scrie-ne la",
    },
  },
  common: { languageLabel: "Limbă", backHome: "Înapoi la pagina principală", loading: "Se încarcă..." },
  philosophy: {"label": "Filozofia", "title": "Regulile de încasare se stabilesc", "titleGreen": "înainte de a începe.", "text": "Uneori e mai bine să refuzi un client decât să accepți unul care te obligă să avansezi timp, bani și resurse fără să știi când vei fi plătit. Centauros îți permite să convii de la început cum, când și cât se va plăti.", "points": ["Definirea politicilor de încasare", "Prevenirea problemelor", "Asigurarea angajamentelor", "Automatizarea urmăririi", "Menținerea controlului financiar", "Reducerea fricțiunii cu clientul"]},
  showcase: {"label": 'Produsul', "slides": [{"id": "control", "title": "Controlează tot ce", "green": "ai de încasat", "text": "O imagine clară a fiecărei încasări și a afacerii tale, mereu la îndemână."}, {"id": "policies", "title": "Tu decizi", "green": "cum și când te plătesc", "text": "Anticipat, avans + rest, la finalizare sau recurent. Alege politica potrivită."}, {"id": "clients", "title": "Fiecare client,", "green": "toată informația necesară", "text": "Date, plăți, abonamente și istoric într-un singur loc."}, {"id": "payments", "title": "Fiecare încasare,", "green": "sub control", "text": "Stare în timp real, mementouri automate și factură instant."}, {"id": "impagos", "title": "Detectează neîncasările", "green": "înainte să crească", "text": "Centauros urmărește, reclamă și te ajută să recuperezi ce e scadent."}, {"id": "facturacion", "title": "Încasări și facturi", "green": "mereu reconciliate", "text": "Emite, verifică și reconciliază toate facturile dintr-un singur loc."}, {"id": "equipo", "title": "Echipa ta,", "green": "totul sub control", "text": "Invită-ți echipa, atribuie roluri și gestionați încasările împreună."}]},
  badges: {"appStoreTop": "Descarcă din", "appStoreLabel": "App Store", "playTop": "Disponibil pe", "playLabel": "Google Play"},
  partners: {"label": "Susținut de cei mai buni parteneri de plată"},
  dashboard: {
    loginTitle: "Panou Centauros", loginSubtitle: "Acces admin privat.",
    email: "Email", password: "Parolă", signIn: "Autentificare", signingIn: "Se conectează...", invalid: "Date incorecte.", logout: "Deconectare",
    nav: { overview: "Prezentare", users: "Utilizatori", workspaces: "Spații", activity: "Activitate", incidents: "Incidente" },
    metrics: { users: "Total utilizatori", active: "Utilizatori activi", workspaces: "Spații", incidents: "Incidente deschise", collected: "Total încasat" },
    tableUsers: { name: "Nume", email: "Email", profession: "Profesie", status: "Stare" },
    tableWorkspaces: { name: "Spațiu", members: "Membri", plan: "Plan", collected: "Încasat" },
    tableIncidents: { title: "Titlu", workspace: "Spațiu", severity: "Severitate", status: "Stare" },
    recentActivity: "Activitate recentă",
  },
  policies: {
    label: "Politici de încasare",
    title: "Tu decizi cum și când ești plătit.",
    subtitle: "Setează politica potrivită pentru fiecare client, iar Centauros o aplică automat.",
    methods: [
      { name: "Plată în avans", desc: "Încasează suma integrală înainte de a începe. Zero risc." },
      { name: "Avans + rest", desc: "Un avans acum și restul la finalul lucrării." },
      { name: "Plată la finalizare", desc: "Clientul plătește automat când termini." },
      { name: "Plată recurentă", desc: "Abonamente și rate care se încasează singure în fiecare perioadă." },
      { name: "Extra ulterioare", desc: "Adaugă costuri suplimentare după serviciu, fără fricțiune." },
      { name: "Plată pe etape", desc: "Împarte încasarea pe faze și încasează pe măsură ce avansezi." },
    ],
    ui: { upfront: "În avans", paid: "Încasat", pending: "În așteptare", total: "Total", deposit: "Avans", balance: "Rest", completed: "Finalizat", dueOnFinish: "La finalizare", monthly: "Lunar", nextCharge: "Următoarea încasare", extra: "Extra", milestone: "Etapă" },
  },
  redesign: { comingSoon: "În curând" },
  appui: { hello: "Salut", toCollect: "De încasat", collected: "Încasat", overdue: "Restant", activity: "Activitate", pending: "În așteptare", paid: "Plătit", advance: "În avans", extra: "Extra", payNow: "Plătește" },
  faqx: [
    { q: "Ce este Centauros?", a: "Centauros este o platformă pentru a defini politici de încasare, a automatiza plățile, a genera facturi și a reduce restanțele fără a-ți urmări clienții. Îți setezi regulile o singură dată, iar aplicația încasează, reamintește și reconciliază în locul tău." },
    { q: "Pentru cine este?", a: "Pentru orice profesionist sau companie care facturează servicii: antrenori, medici veterinari, avocați, consultanți, agenții, clinici, săli de sport sau firme de servicii. Fie recurent, fie pe proiect, Centauros se adaptează modului tău de lucru." },
    { q: "Clienții mei trebuie să instaleze aplicația?", a: "Nu. Clienții tăi primesc linkuri de plată și mesaje direct, fără să descarce nimic. Doar tu, profesionistul, folosești aplicația Centauros." },
    { q: "Ce metode de plată pot accepta?", a: "Datorită Stripe poți accepta carduri de credit și debit, Apple Pay, Google Pay și celelalte metode disponibile în țara ta. Metodele concrete depind de acoperirea Stripe în fiecare regiune." },
    { q: "Pot decide cum și când sunt plătit?", a: "Da. Plată în avans, avans + rest, plată la finalizare, plăți recurente, extra ulterioare sau plată pe etape. Alegi politica potrivită pentru fiecare client sau serviciu." },
    { q: "Centauros generează facturile automat?", a: "Da. Poate crea ciorne, emite facturi automat după plată sau urma politica de facturare pe care o configurezi. Toate sunt înregistrate și gata de trimis." },
    { q: "Ce se întâmplă dacă un client nu plătește?", a: "Centauros face urmărirea pentru tine: memento-uri automate, controlul scadențelor și marcarea restanțelor, ajutându-te să recuperezi sumele fără conversații incomode." },
    { q: "Este sigur să folosesc Centauros?", a: "Da. Plățile sunt procesate integral prin Stripe, datele circulă criptate și nu stocăm niciodată datele cardurilor. Platforma urmează bune practici de securitate." },
    { q: "În ce țări este disponibil?", a: "Centauros este conceput să funcționeze internațional. Metodele de plată disponibile depind de țările acceptate de Stripe, care acoperă majoritatea piețelor din Europa, America și alte regiuni." },
    { q: "Cum încep?", a: "Descarcă aplicația, creează-ți contul și configurează prima politică de încasare în câteva minute. De acolo poți începe să încasezi și să-ți automatizezi plățile." },
  ],
  legalx: {
    eyebrow: "Legal", contents: "Cuprins", questions: "Întrebări despre această pagină? Scrie-ne.",
    navPrivacy: "Confidențialitate", navTerms: "Termeni", navCookies: "Cookie-uri", navSupport: "Asistență",
    cookiesMetaTitle: "Politica de cookie-uri — Centauros", cookiesMetaDesc: "Cum folosește Centauros cookie-urile și tehnologiile similare.",
  },
  product2: {
    p1title: "Nu mai alerga după bani. Începe să încasezi.",
    p1sub: "Urmărirea manuală te face să pierzi bani. Cu Centauros stabilești politica și ești plătit automat, fără conversații stânjenitoare.",
    p1cta: "Descarcă Centauros",
    p1link: "Află cum funcționează",
    p1cardTitle: "Din fiecare 1.000 € facturați",
    p1cardCol: "Chiar încasezi",
    p1rows: [
      { name: "Centauros", amount: "1.000 €" },
      { name: "Memento-uri manuale", amount: "910 €", delta: "−90 €" },
      { name: "Fără urmărire", amount: "820 €", delta: "−180 €" },
    ],
    p2title: "Fii plătit pentru munca ta, fără fricțiuni.",
    p2sub: "Linkuri de plată, politici și facturi automate. Stabilești regulile o dată, iar Centauros face restul.",
    p2cta: "Află cum funcționează",
    p2policy: "Politică · Avans + sold",
    p2sendLabel: "Clientul plătește",
    p2client: "Client",
    p2info: "Plată recurentă? Configureaz-o o dată și se încasează singură în fiecare perioadă.",
    p2recipLabel: "Tu primești",
    p2you: "Tu",
    p2arrives: "Încasat",
    p2arrivesVal: "Azi · automat",
    p2fees: "Comisioane",
    p2feesVal: "Incluse",
    p3title: "Fă mult mai mult cu Centauros.",
    p3sub: "Nu e doar despre încasare: gestionează clienți, facturi, restanțe și echipa dintr-un singur loc.",
    p3cta: "Creează cont",
    p3cardLabel: "De încasat",
    p3feat: "Primești plăți instant",
    p3featDesc: "Linkuri de plată și încasări automate, susținute de infrastructura Stripe.",
    p3check: "Mai multe metode de plată",
    p3cta2: "Explorează încasările",
    p4title: "Recuperează restanțele pe care le dădeai pierdute.",
    p4sub: "Centauros urmărește automat plățile întârziate cu memento-uri și reîncercări, până când ești plătit.",
    p4cta: "Află cum funcționează",
    p4cardLabel: "Restanțe recuperate",
    p4foot: "Profesioniștii recuperează în medie cu 38% mai multe restanțe în primele 6 luni.",
  },
  pricing: {
    label: "Prețuri",
    title: "Prețuri clare. Fără surprize.",
    subtitle: "Plătești doar când încasezi. Stripe percepe comisionul său pentru procesarea plății, iar Centauros adaugă 1% pentru automatizare, gestionarea încasărilor și întreaga platformă.",
    stripeTitle: "Comision Stripe",
    stripeDesc: "Stripe procesează plata în siguranță. Comisionul variază în funcție de țară și metoda de plată; exemplul afișat este pentru cardurile europene.",
    centaurosTitle: "Comision Centauros",
    centaurosDesc: "1% din sumă pentru automatizare, urmărirea încasărilor și întreaga platformă. Fără costuri lunare ascunse.",
    calcTitle: "Calculează cât primești",
    invoiceAmount: "Suma facturii",
    stripeFee: "Comision Stripe",
    centaurosFee: "Comision Centauros (1%)",
    received: "Profesionistul primește",
    note: "Comisionul real Stripe poate varia în funcție de țară și metoda de plată. Sumele afișate sunt un exemplu orientativ.",
  },
  cookie: {
    title: "Confidențialitatea ta, alegerea ta",
    intro: "Folosim cookie-uri pentru ca Centauros să funcționeze corect, să reținem preferințele tale și să înțelegem anonim cum este utilizat site-ul. Tu alegi ce activezi și te poți răzgândi oricând.",
    required: "Mereu active",
    acceptAll: "Acceptă toate",
    rejectAll: "Respinge toate",
    save: "Salvează preferințele",
    reopen: "Preferințe cookie",
    footnote: "Îți poți modifica consimțământul oricând din subsolul paginii.",
    policyLink: "Politica de cookie-uri",
    categories: {
      necessary: { name: "Necesare", desc: "Esențiale pentru funcționarea și securitatea site-ului. Nu pot fi dezactivate." },
      preferences: { name: "Preferințe", desc: "Rețin setările tale, precum limba, pentru o experiență mai confortabilă." },
      analytics: { name: "Analitice", desc: "Ne ajută să înțelegem anonim cum este folosit site-ul pentru a-l îmbunătăți." },
      marketing: { name: "Marketing", desc: "Permit afișarea de conținut și reclame mai relevante, pe site și în afara lui." },
    },
  },
};
export default ro;
